var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassPanel",
    {
      attrs: { value: true, size: "large", title: _vm.value.title },
      on: { beforeClose: _vm.close }
    },
    [
      _c(
        "template",
        { slot: "default" },
        [
          _vm.loading
            ? _c("CompassLoader", {
                staticClass: "overview-panel-container--loader",
                attrs: { size: "large", color: "sellsy-brand-primary-100" }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "overview-panel-container__content",
              class: { "overview-panel-container__content--load": _vm.loading }
            },
            [
              _c("iframe", {
                attrs: {
                  id: "overview-panel-iframe",
                  src: _vm.value.data,
                  width: "100%",
                  height: "960",
                  type: "application/pdf"
                },
                on: { load: _vm.loaded }
              })
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.value.settings
        ? _c(
            "template",
            { slot: "footer" },
            [
              !_vm.isMain
                ? _c("CompassButton", {
                    attrs: {
                      loading: _vm.isLoading,
                      label: _vm.$t.__("common.actions.unlink"),
                      type: "secondary"
                    },
                    on: { click: _vm.unlink }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("CompassButton", {
                attrs: {
                  loading: _vm.isLoading,
                  label: _vm.$t.__(
                    "overview.panels.OverviewPanel.declare_as_main_document"
                  ),
                  disabled: _vm.isMain,
                  type: "secondary"
                },
                on: { click: _vm.setMainDocument }
              }),
              _vm._v(" "),
              _vm.canSendEmail
                ? _c("CompassButton", {
                    attrs: {
                      loading: _vm.isLoading,
                      label: _vm.$t.__(
                        "overview.panels.OverviewPanel.send_by_mail"
                      )
                    },
                    on: { click: _vm.send }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }